/**
 * quotes.js — daily rotating quotes.
 * All 61 quotes exactly matching the original index.html.
 * getDailyQuote() returns a different quote each calendar day.
 */

const QUOTES = [
  { t: 'The secret of getting ahead is getting started.', a: 'Mark Twain' },
  { t: "You don't have to be great to start, but you have to start to be great.", a: 'Zig Ziglar' },
  { t: 'In the middle of difficulty lies opportunity.', a: 'Albert Einstein' },
  { t: 'It does not matter how slowly you go as long as you do not stop.', a: 'Confucius' },
  { t: "Believe you can and you're halfway there.", a: 'Theodore Roosevelt' },
  { t: 'Act as if what you do makes a difference. It does.', a: 'William James' },
  { t: 'Success is not final, failure is not fatal: it is the courage to continue that counts.', a: 'Winston Churchill' },
  { t: 'Happiness is not something ready-made. It comes from your own actions.', a: 'Dalai Lama' },
  { t: 'Keep your face always toward the sunshine and shadows will fall behind you.', a: 'Walt Whitman' },
  { t: 'You are never too old to set another goal or to dream a new dream.', a: 'C.S. Lewis' },
  { t: 'The best time to plant a tree was 20 years ago. The second best time is now.', a: 'Chinese Proverb' },
  { t: 'Spread love everywhere you go.', a: 'Mother Teresa' },
  { t: 'The future belongs to those who believe in the beauty of their dreams.', a: 'Eleanor Roosevelt' },
  { t: 'It is during our darkest moments that we must focus to see the light.', a: 'Aristotle' },
  { t: 'Whoever is happy will make others happy too.', a: 'Anne Frank' },
  { t: 'You will face many defeats in life, but never let yourself be defeated.', a: 'Maya Angelou' },
  { t: 'The greatest glory in living lies not in never falling, but in rising every time we fall.', a: 'Nelson Mandela' },
  { t: "In the end, it's not the years in your life that count. It's the life in your years.", a: 'Abraham Lincoln' },
  { t: 'Life is either a daring adventure or nothing at all.', a: 'Helen Keller' },
  { t: 'You are enough just as you are.', a: 'Meghan Markle' },
  { t: 'Be yourself; everyone else is already taken.', a: 'Oscar Wilde' },
  { t: 'Start where you are. Use what you have. Do what you can.', a: 'Arthur Ashe' },
  { t: 'Tough times never last, but tough people do.', a: 'Robert H. Schuller' },
  { t: 'You must be the change you wish to see in the world.', a: 'Mahatma Gandhi' },
  { t: "Life is what happens when you're busy making other plans.", a: 'John Lennon' },
  { t: "Don't count the days, make the days count.", a: 'Muhammad Ali' },
  { t: 'Happiness is not by chance, but by choice.', a: 'Jim Rohn' },
  { t: 'Each day is a new beginning. Take a deep breath and start again.', a: 'Unknown' },
  { t: 'Be gentle with yourself. You are a child of the universe.', a: 'Max Ehrmann' },
  { t: 'Rest is not idleness.', a: 'John Lubbock' },
  { t: 'Small steps every day.', a: 'Unknown' },
  { t: 'You have survived every hard day so far.', a: 'Unknown' },
  { t: 'This too shall pass.', a: 'Persian Proverb' },
  { t: 'One day at a time.', a: 'Unknown' },
  { t: 'Progress, not perfection.', a: 'Unknown' },
  { t: 'Be kind to yourself.', a: 'Unknown' },
  { t: 'Health is the greatest gift, contentment the greatest wealth.', a: 'Buddha' },
  { t: 'The purpose of our lives is to be happy.', a: 'Dalai Lama' },
  { t: 'Go confidently in the direction of your dreams.', a: 'Henry David Thoreau' },
  { t: 'Believe that life is worth living and your belief will help create the fact.', a: 'William James' },
  { t: 'To know even one life has breathed easier because you have lived — this is to have succeeded.', a: 'Ralph Waldo Emerson' },
  { t: 'Only a life lived for others is a life worthwhile.', a: 'Albert Einstein' },
  { t: "Don't judge each day by the harvest you reap but by the seeds that you plant.", a: 'Robert Louis Stevenson' },
  { t: 'Do not go where the path may lead; go instead where there is no path and leave a trail.', a: 'Ralph Waldo Emerson' },
  { t: "Many of life's failures are people who did not realize how close they were to success when they gave up.", a: 'Thomas Edison' },
  { t: "If you look at what you have in life, you'll always have more.", a: 'Oprah Winfrey' },
  { t: 'Your time is limited, so don\'t waste it living someone else\'s life.', a: 'Steve Jobs' },
  { t: 'The whole secret of a successful life is to find out what is one\'s destiny to do, and then do it.', a: 'Henry Ford' },
  { t: 'Live in the sunshine, swim the sea, drink the wild air.', a: 'Ralph Waldo Emerson' },
  { t: 'In this life we cannot do great things. We can only do small things with great love.', a: 'Mother Teresa' },
  { t: 'You only live once, but if you do it right, once is enough.', a: 'Mae West' },
  { t: 'Not how long, but how well you have lived is the main thing.', a: 'Seneca' },
  { t: 'If life were predictable it would cease to be life and be without flavour.', a: 'Eleanor Roosevelt' },
  { t: 'Few things can help an individual more than to place responsibility on him.', a: 'Booker T. Washington' },
  { t: 'To accomplish great things, we must not only act, but also dream.', a: 'Anatole France' },
  { t: 'Tell me and I forget. Teach me and I remember. Involve me and I learn.', a: 'Benjamin Franklin' },
  { t: 'When you reach the end of your rope, tie a knot in it and hang on.', a: 'Franklin D. Roosevelt' },
  { t: 'Always remember that you are absolutely unique. Just like everyone else.', a: 'Margaret Mead' },
  { t: 'The only way to do great work is to love what you do.', a: 'Steve Jobs' },
  { t: 'Never let the fear of striking out keep you from playing the game.', a: 'Babe Ruth' },
  { t: "Everything you've ever wanted is on the other side of fear.", a: 'George Addair' },
]

/**
 * Returns the quote for today — same quote all day, changes at midnight.
 */
export function getDailyQuote() {
  const dayIndex = Math.floor(Date.now() / 86400000)
  return QUOTES[dayIndex % QUOTES.length]
}

/**
 * Returns a time-of-day greeting string.
 */
export function getGreeting() {
  const hour = new Date().getHours()
  if (hour >= 22 || hour < 5) return 'Good night 🌙'
  if (hour >= 17) return 'Good evening 🌿'
  if (hour >= 12) return 'Good afternoon 🌿'
  return 'Good morning 🌿'
}
